import styled from 'styled-components/macro'

import { Field, Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const TotalField = styled(Field)`
  padding: ${toCSSValue('spacing-1')} 0;
  grid-column: 1 / 3;
  background-color: ${toCSSValue('color-success-20')};

  ${screen.md} {
    padding: 0;
    grid-column: auto;
    background-color: transparent;
  }
`

export const TotalValueWrapper = styled(Layout.Group)`
  ${screen.md} {
    height: ${toCSSValue('spacing-10')};
  }
`
